/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  PNL_CHART_RESET,
  UPDATE_PNL_CHART_FETCH_OPTIONS,
  UPDATE_PNL_CHART_CALC_OPTIONS,
  SELECT_PNL_CHART_CLIENT_ID_DATA,
  UPDATE_PNL_CHART_CLIENT_ID_FILTER_SEARCH,
  UPDATE_PNL_CHART_CLIENT_ID_CACHE,
  SELECT_PNL_CHART_ALGO_DATA,
  UPDATE_PNL_CHART_ALGO_FILTER_SEARCH,
  UPDATE_PNL_CHART_ALGO_CACHE,
  UPDATE_PNL_CHART_ALGO_FILTER_BROKER,
  FETCH_PNL_CHART_DATA_REQUEST,
  FETCH_PNL_CHART_DATA_SUCCESS,
  FETCH_PNL_CHART_DATA_FAILURE,
  PNL_CHART_DATA_RESET,
  CHART_PNL_LIVE_FEED,
  PNL_CHART_UNDERLYING_DATA_RESET,
  FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE,
  FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS,
  FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST,
  CHART_UNDERLYINNG_PNL_LIVE_FEED,
  FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST,
  FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS,
  FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE,
  PNL_CHART_CHART_CLIENT_ID_LIST_RESET,
  FETCH_PNL_CHART_ALGO_LIST_REQUEST,
  FETCH_PNL_CHART_ALGO_LIST_SUCCESS,
  FETCH_PNL_CHART_ALGO_LIST_FAILURE,
  PNL_CHART_CHART_ALGO_LIST_RESET,
  CHART_PNL_UPDATE_LAST_VALUE,
  FETCH_PNL_CHART_NEXT_DATA_SUCCESS,
  FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS,
} from '../../constants/ActionTypes';
import { getFormattedDate } from '../../utils';
import { chartTypeTypes } from '../../partials/PnlChart/LayoutControls/ChartType';
import {
  updateChartData,
  updateSelect,
  updateChartLiveData,
  updateChartUnderlyingData,
  updateChartCombineUnderlyingData,
  updateChartLiveUnderlyingData,
  updateMtmTotal,
  updateNextChartData,
} from './updators';

export function setPnlChartSearchParams(data = {}) {
  const url = new URL(window.location.href);

  url.searchParams.set('dt', data.date);
  url.searchParams.set('ct', data.chartType);

  if (data.underlying) {
    url.searchParams.set('ul', data.underlying);
  } else {
    url.searchParams.delete('ul');
  }

  window.history.pushState(null, '', url.toString());
}

export function updatePnlChartSpecialSearchParams(name, value) {
  const urlParams = new URLSearchParams(window.location.search);

  urlParams.set(name, value);

  const url = new URL(window.location.href);

  url.search = urlParams.toString();

  window.history.pushState(null, '', url.toString());
}

export function getPnlChartSearchParams(loactionParam) {
  const fromDate = getFormattedDate(null, 'YYYY-MM-DD');
  const todate = fromDate;
  const urlParams = new URLSearchParams(loactionParam.search);
  const date = urlParams.get('dt') || `${fromDate}_${todate}`;
  const chartType = urlParams.get('ct') || chartTypeTypes[0].value;
  const underlying = urlParams.get('ul') || undefined;
  let broker = urlParams.get('broker')?.trim()
    ? urlParams.get('broker').split(',')
    : [];

  broker = broker.length ? [broker[0]] : [];
  let algo = urlParams.get('algo')?.trim()
    ? urlParams.get('algo').split(',')
    : [];

  algo = algo.length ? [algo[0]] : [];

  return {
    date,
    chartType,
    underlying,
    broker,
    algo,
  };
}

function getDefaultFetchParamData() {
  const { date } = getPnlChartSearchParams(window.location);

  return {
    date,
  };
}

function getDefaultCalcParamData() {
  const { chartType, underlying } = getPnlChartSearchParams(window.location);

  return {
    chartType,
    underlying,
  };
}

const fetchOptions = (
  state = {
    ...getDefaultFetchParamData(),
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_PNL_CHART_FETCH_OPTIONS:
      return {
        ...state,
        ...action.data,
        updatedAt: new Date(),
      };
    case PNL_CHART_RESET:
      return {
        ...state,
        ...getDefaultFetchParamData(),
        updatedAt: null,
      };
    default:
      return state;
  }
};

const calcOptions = (
  state = {
    ...getDefaultCalcParamData(),
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_PNL_CHART_CALC_OPTIONS:
      return {
        ...state,
        ...action.data,
        updatedAt: new Date(),
      };
    case PNL_CHART_RESET:
      return {
        ...state,
        ...getDefaultCalcParamData(),
        updatedAt: null,
      };
    default:
      return state;
  }
};

const chartData = (
  state = {
    updatedAt: null,
    data: [],
    isFetching: false,
    error: {},
    paging: null,
    metaData: null,
    graphLevel: '',
    filterList: [],
    firstEntryTime: null,
    lastEntryTime: null,
    query: {},
    liveUpdateAt: null,
    pnlFeed: [],
  },
  action
) => {
  switch (action.type) {
    case FETCH_PNL_CHART_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: {},
      };
    case FETCH_PNL_CHART_DATA_SUCCESS:
      const pnlChartData = updateChartData(action);

      return {
        ...state,
        isFetching: false,
        error: {},
        data: pnlChartData.responseData,
        paging: action?.data?.data?.paging || null,
        metaData: action?.data?.data?.metaData || null,
        firstEntryTime: pnlChartData.firstEntryTime,
        lastEntryTime: pnlChartData.lastEntryTime,
        graphLevel: action.graphLevel,
        filterList: action.filterList,
        updatedAt: Date.now(),
        query: action?.query || {},
        pnlFeed: [],
      };
    case FETCH_PNL_CHART_NEXT_DATA_SUCCESS:
      const pnlChartNextData = updateNextChartData(action, state);

      return {
        ...state,
        isFetching: false,
        error: {},
        data: pnlChartNextData.responseData,
        paging: action?.data?.data?.paging || null,
        metaData: action?.data?.data?.metaData || null,
        firstEntryTime: pnlChartNextData.firstEntryTime,
        lastEntryTime: pnlChartNextData.lastEntryTime,
        updatedAt: Date.now(),
        pnlFeed: [],
      };
    case FETCH_PNL_CHART_DATA_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case CHART_PNL_LIVE_FEED:
      const pnlChartLiveFeed = updateChartLiveData(action, state);

      return {
        ...state,
        liveUpdateAt: pnlChartLiveFeed.liveUpdateAt,
        pnlFeed: pnlChartLiveFeed.pnlFeed,
      };
    case CHART_PNL_UPDATE_LAST_VALUE:
      const pnlChartLastvalue = updateMtmTotal(state);

      return {
        ...state,
        metaData: pnlChartLastvalue.metaData,
        firstEntryTime: pnlChartLastvalue.firstEntryTime,
        lastEntryTime: pnlChartLastvalue.lastEntryTime,
        data: pnlChartLastvalue.responseData,
        pnlFeed: [],
        updatedAt: Date.now(),
      };
    case PNL_CHART_DATA_RESET:
    case PNL_CHART_RESET:
      return {
        ...state,
        updatedAt: null,
        paging: null,
        metaData: null,
        data: [],
        isFetching: false,
        error: {},
        graphLevel: '',
        filterList: [],
        firstEntryTime: null,
        lastEntryTime: null,
        query: {},
        liveUpdateAt: null,
        pnlFeed: [],
      };
    default:
      return state;
  }
};

const chartUnderlyingData = (
  state = {
    updatedAt: null,
    data: [],
    isFetching: false,
    error: {},
    underlying: undefined,
    paging: null,
  },
  action
) => {
  switch (action.type) {
    case FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: {},
      };
    case FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        data: updateChartUnderlyingData(action),
        paging: action?.data?.data?.paging || null,
        underlying: action.underlying,
        updatedAt: Date.now(),
      };
    case FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        data: updateChartCombineUnderlyingData(
          action?.data?.data?.data || [],
          state,
          action.underlying
        ),
        paging: action?.data?.data?.paging || null,
        updatedAt: Date.now(),
      };
    case FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case CHART_UNDERLYINNG_PNL_LIVE_FEED:
      return {
        ...state,
        data: updateChartLiveUnderlyingData(action, state),
        updatedAt: Date.now(),
      };
    case PNL_CHART_UNDERLYING_DATA_RESET:
    case PNL_CHART_RESET:
      return {
        ...state,
        updatedAt: null,
        paging: null,
        data: [],
        isFetching: false,
        error: {},
        underlying: undefined,
      };
    default:
      return state;
  }
};

const clientIdList = (
  state = {
    updatedAt: null,
    modifiedAt: null,
    data: [],
    dataCached: [],
    isFetching: false,
    error: {},
    filters: {
      search: '',
      updatedAt: null,
    },
  },
  action
) => {
  switch (action.type) {
    case FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        data: action.data,
      };
    case FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case SELECT_PNL_CHART_CLIENT_ID_DATA:
      const clientIdSelectData = updateSelect(
        state.data,
        action.id,
        action.select
      );

      const clientIdSelectDataCached = updateSelect(
        state.dataCached,
        action.id,
        action.select
      );

      return {
        ...state,
        data: clientIdSelectData,
        dataCached: clientIdSelectDataCached,
        modifiedAt: new Date(),
      };
    case UPDATE_PNL_CHART_CLIENT_ID_FILTER_SEARCH:
      return {
        ...state,
        filters: {
          ...state.filters,
          search: action.data,
          updatedAt: new Date(),
        },
      };
    case UPDATE_PNL_CHART_CLIENT_ID_CACHE:
      return {
        ...state,
        dataCached: action.data,
        updatedAt: new Date(),
      };
    case PNL_CHART_CHART_CLIENT_ID_LIST_RESET:
    case PNL_CHART_RESET:
      return {
        ...state,
        updatedAt: null,
        modifiedAt: null,
        data: [],
        dataCached: [],
        isFetching: false,
        error: {},
        filters: {
          search: '',
          updatedAt: null,
        },
      };
    default:
      return state;
  }
};

const algoList = (
  state = {
    updatedAt: null,
    modifiedAt: null,
    data: [],
    dataCached: [],
    isFetching: false,
    error: {},
    filters: {
      search: '',
      broker: '',
      updatedAt: null,
    },
  },
  action
) => {
  switch (action.type) {
    case FETCH_PNL_CHART_ALGO_LIST_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case FETCH_PNL_CHART_ALGO_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        data: action.data,
      };
    case FETCH_PNL_CHART_ALGO_LIST_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case SELECT_PNL_CHART_ALGO_DATA:
      const clientIdSelectData = updateSelect(
        state.data,
        action.id,
        action.select
      );

      const clientIdSelectDataCached = updateSelect(
        state.dataCached,
        action.id,
        action.select
      );

      return {
        ...state,
        data: clientIdSelectData,
        dataCached: clientIdSelectDataCached,
        modifiedAt: new Date(),
      };
    case UPDATE_PNL_CHART_ALGO_FILTER_SEARCH:
      return {
        ...state,
        filters: {
          ...state.filters,
          search: action.data,
          updatedAt: new Date(),
        },
      };
    case UPDATE_PNL_CHART_ALGO_FILTER_BROKER:
      return {
        ...state,
        filters: {
          ...state.filters,
          broker: action.data,
          updatedAt: new Date(),
        },
      };
    case UPDATE_PNL_CHART_ALGO_CACHE:
      return {
        ...state,
        dataCached: action.data,
        updatedAt: new Date(),
      };
    case PNL_CHART_CHART_ALGO_LIST_RESET:
    case PNL_CHART_RESET:
      return {
        ...state,
        updatedAt: null,
        modifiedAt: null,
        data: [],
        dataCached: [],
        isFetching: false,
        error: {},
        filters: {
          search: '',
          broker: '',
          updatedAt: null,
        },
      };
    default:
      return state;
  }
};

const pnlChart = combineReducers({
  fetchOptions,
  calcOptions,
  chartData,
  chartUnderlyingData,
  clientIdList,
  algoList,
});

export default pnlChart;
